<template lang="pug">
van-popup(v-model="show" closeable :style="{ width: '86%', height: '52%' }")
  .open_box {{ t('opening_hours', 'Opening hours') }}
  .open_content
    .content_list(v-for="(item, i) in weekData" :key="i")
      .list_label {{ item.week }}
      .list_item
        div(v-if="!!item.hourSettings.length && item.hourSettings.length > 0" v-for="ls, index in item.hourSettings" :key="index") {{ ls.fromHour + ' - ' + ls.toHour }}
        div(v-if="!item.hourSettings.length || item.hourSettings.length === 0") {{ item.enable ? item.fromHour + ' - ' + item.toHour : t('closed', 'Closed') }}
</template>

<script>
import Vue from 'vue'
import { Dialog, } from 'muse-ui'
import dayjs from 'dayjs'
import { t } from '@/utils/language'
Vue.use(Dialog)

export default {
  props: {
    weeklyOperatingHours: Object
  },
  data() {
    return {
      weekData: [],
      show: false
    }
  },
  watch: {
    weeklyOperatingHours(val) {
      const weekOrderList = [
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
        'sunday'
      ]
      this.weekData = this._getOrderedWeekTimeList(weekOrderList, JSON.parse(JSON.stringify(val)))
    }
  },

  methods: {
    t(key, fallback) {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      return t(key, fallback)
    },

    onOverlany() {
      this.show = true
    },

    _getOrderedWeekTimeList(weekOrderList, weeklyOperatingHours) {
      return weekOrderList.map(item => {
        const fromHour = weeklyOperatingHours[item].fromHour.slice(0, 2)
        const toHour = weeklyOperatingHours[item].toHour.slice(0, 2)

        return {
          ...weeklyOperatingHours[item],
          week: item
        }
      })
    }
  },
}
</script>

<style lang="sass" scoped>
  ::v-deep
    .van-popup
      border-radius: 15px !important

  ::v-deep
    .van-icon-cross::before
      color: #1FC4BC

  .open_box
    text-align: center
    font-size: 18px
    font-weight: bold
    line-height: 50px
    color: #334455
    background: #f3f3f3

  .open_content
    padding: 0 15px

    .content_list
      display: flex
      justify-content: space-between
      border-bottom: 0.1px solid #f3f3f3
      padding-bottom: 8px
      padding-top: 10px

      .list_label
        display: flex
        justify-content: center
        align-items: center
        font-size: 14px
        font-weight: bold
        line-height: 18px
        color: #334455
        text-transform: Capitalize

      .list_item
        font-size: 14px
        font-weight: 400
        line-height: 18px
        color: #334455
        opacity: 0.75
</style>
